import { Outlet } from 'react-router';

import { WithOnboardingComponents } from '#src/components/onboarding/WithOnboardingComponents/index.tsx';

const SeriesPlayLayout = () => {
  return (
    <WithOnboardingComponents queryLoading={false}>
      <Outlet />
    </WithOnboardingComponents>
  );
};
export default SeriesPlayLayout;
